module.exports = __webpack_public_path__ + "static/img/logo_1ga_169x164.f1c5f27b.jpg";